<ng-container *transloco="let t">
  @if (label) {
  <label>{{ label }}

    @if (errors?.['required']) {
    <small>*</small>
    }
  </label>
  }
  <app-dropdown (dropdownClosed)="dropdownClosed($event)" [disabled]="disabled" [isDropdownListFullWidth]="true">
    <div dropdownPanel>
      <div class="panel" [class.error]="touched && invalid" [class.disabled]="disabled">
        <div class="d-flex align-items-center" dropdownToggle>
            @if (selectedCountry) {
             @if (selectedCountry.isoCode) {
               <span [class]="'fi fi-'+selectedCountry.isoCode.toLowerCase()" style="scale: 80%"></span>
             }
             <span class="ps-1 pe-1">
               {{ selectedCountry.callCode }}
             </span>
             } @else {
             <span class="ps-1 pe-1"> +000</span>
            }
        </div>
        <input class="number-input flex-grow-1 d-flex" [disabled]="disabled"
          [placeholder]="numberPlaceholder" [ngModel]="localNumber" (ngModelChange)="onNumberInput($event)" />
      </div>
    </div>
    <div dropdownContent>
      <div class="search-wrapper">
          <i class="bi bi-search ps-1"></i>
          <input [placeholder]="searchPlaceholder ?? t('explore.search')" class="search-input ps-2 d-flex"
            [ngModel]="searchText" (ngModelChange)="onSearch($event)" />
      </div>
      <div class="dropdown-list-wrapper">
        @if (filteredCountries.length > 0) {
          @for (country of filteredCountries;track country;let idx = $index) {
            <div (click)="selectCountry(country)" class="select-item">
              <div class="option-label" [ngClass]="{'selected': country.id === selectedCountry?.id}">
                <div class="d-flex justify-content-start align-items-center">
                  @if (country.isoCode) {
                    <span [class]="'fi fi-' + country.isoCode.toLowerCase()" style="scale: 80%"></span>
                  }
                  <span class="ps-2">
                    {{ t('app.common.country.' + country.id) }}
                  </span>
                  <span class="ps-2 opacity-50 fw-300"> ({{ country.callCode }})</span>
                </div>
              </div>
            </div>
          }
        }
        @else {
        <span class="empty-list">
        {{ t("emptyState.not.able.to.find") }}
        </span>
        }
      </div>
    </div>
  </app-dropdown>
  @if (touched) {
  @for(errorMessage of errors | errorMessages; track errorMessage){
  <span class="errorMes pt-1">{{ errorMessage }} </span>
  }
  }
</ng-container>
